<template>
  <div v-redirect-if-no-permission:MARKETING_VOUCHERS :key="switch1">
    <loading-component :value="loading" />

    <DataTable ref="dataTable" :url="'voucher'" :enable-edit="false" :enable-add="false" :enable-delete="false"
      :formatter="formatters" :actions-extra-main="actionsExtraMain" perPage="10" :fields-hidden-main="['full_name','type']"
      :titles="titles" :title='$t("vouchersPage.pageTitleMarketingExpired")' :initial-url-search-params="tableParams" />

   
  </div>
</template>

<script>
import DataTable from "@/components/monaco/DataTable";
import { formatCompanyTime } from "@/util/companyTime";
import LoadingComponent from "@/components/LoadingComponent";

export default {
  name: "MarketingExpiredVouchers",
  title() {
    return this.$t("vouchersPage.pageTitleMarketingExpired");
  },
  components: {
    LoadingComponent,
    DataTable
  },
  data() {
    return {
      formKey: 0,
      rules: {
        length: (len) => (v) =>
          (v || "").length >= len || this.$t("vouchersPage.ruleLength", { len }),
        required: (v) => !!v || this.$t("vouchersPage.ruleRequired"),
        number: (v) => /^\d+(\.\d+)?$/.test(v) || this.$t("vouchersPage.ruleNumber")
      },
      loading: false,
      dialogLoading: false,
      dialog: false,
      selectedCaptain: null,
      paidAmount: 0,
      switch1: null,
    };
  },

  computed: {
    formatters() {
      return {
        created_at(value) {
          return value ? formatCompanyTime(value, "YYYY-MM-DD") : "";
        },
        admin_name: (value) => value || this.$t("vouchersPage.system"),
        discount_type: (value) =>
          value == "PERCENTAGE" ? "%" : this.$t("vouchersPage.discountTypeFixed"),
        active(val) {
          return `
                        <i class="v-icon fa ${val ? "fa-check" : "fa-close"
            }"></i>
                        `;
        },
      };
    },
    titles() {
      return {
        id: "#",
        title: this.$t("vouchersPage.title"),
        code: this.$t("vouchersPage.code"),
        discount_type: this.$t("vouchersPage.discountType"),
        amount: this.$t("vouchersPage.amount"),
        start_date: this.$t("vouchersPage.startDate"),
        end_date: this.$t("vouchersPage.endDate"),
        use_times: this.$t("vouchersPage.useTimes"),
        max_redemption: this.$t("vouchersPage.maxRedemption"),
        used_amount: this.$t("vouchersPage.usedAmount"),
        admin_name: this.$t("vouchersPage.createdBy"),
        active: this.$t("vouchersPage.active"),
        created_at: this.$t("vouchersPage.creationDate")
      };
    },
    tableParams() {
      const params = new URLSearchParams();
      params.append("type", "PROMOTIONAL");
      return params;
    },
    actionsExtraMain() {
      return {
       
      };
    },

  },
  watch: {

    dialog: function (val) {
      this.dialogLoading = false;
      if (!val)
        this.selectedCaptain = null;
      else
        this.formKey++;

      this.paidAmount = 0;

    },
  },
  methods: {

  },
};
</script>

<style scoped></style>
